import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TeethDiagramQuery } from '@modules/teeth-diagram/state/teeth-diagram-query';
import { Tooth } from '@modules/teeth-diagram/models/tooth';
import { SharedModule } from '@shared/shared.module';
import { RxModel } from '@shared/models/rx-models/interfaces/rx-model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getToothNumberById } from '@modules/teeth-diagram/models/teeth-numbering';
import { ArtTreatmentIndication, ArtTreatmentIntegrity } from '@modules/rx-intuitive-art/models';
import { isArtTreatmentUnassigned } from '@modules/rx-intuitive-art/constants/art-treatment.constants';

@Component({
	selector: 'rx-treatment-information-art',
	standalone: true,
	templateUrl: './treatment-information-art.component.html',
	styleUrls: ['../base/treatment-information-base.component.scss'],
	imports: [CommonModule, SharedModule]
})
export class TreatmentInformationArtComponent {
	@Input() rxForPrint?: { rx: RxModel };

	readonly displayedColumns = ['Tooth No', 'Treatment', 'Material', 'Preparation design', 'Shade'];

	constructor(private readonly teethDiagramQuery: TeethDiagramQuery) {}

	get treatments(): Tooth[] {
		return (this.rxForPrint?.rx.Teeth ?? [])
			.filter(tooth => tooth.ArtTreatment != null)
			.filter(
				tooth =>
					!isArtTreatmentUnassigned(
						tooth.ToothID,
						tooth.ArtTreatment?.Integrity as ArtTreatmentIntegrity | undefined,
						tooth.ArtTreatment?.Definitions
					)
			)
			.sort((a, b) => (a.ToothID ?? 0) - (b.ToothID ?? 0));
	}

	getToothNumberById(toothId: number): Observable<number | string> {
		return this.teethDiagramQuery.teethNumberingSystem$.pipe(
			map(teethNumberingSystem => getToothNumberById({ toothId, teethNumberingSystem }))
		);
	}

	getTreatmentIndications(tooth: Tooth): ArtTreatmentIndication[] {
		const treatment = tooth.ArtTreatment;

		if (!treatment) {
			return [];
		}

		return [treatment.Integrity, ...(treatment.Definitions ?? [])] as ArtTreatmentIndication[];
	}
}
